import api from '@/command/api'
import orderConfig from '@/orderConfig'
import { getAction, getParams, downloadAction } from '@/command/netTool'

export const farmingExperienceMixin = {
  methods: {
    // 获取选中订单详情
    getDetailFarmingExperience(id) {
      return new Promise((resolve, reject) => {
        getAction(`/api/farming/order/detail?id=${id}`)
          .then(result => {
            resolve(result.data)
          })
          .catch(e => reject && reject(e))
      })
    },
    onRowSelectFarmingExperience(orderId, orderItemId) {

      const ext = [
        // 表格
        orderConfig.table,
        // // 退款信息
        // orderConfig.retuenInfo,
        // 可选择表格
        orderConfig.tableTicketsSelect,
        // 基本信息
        orderConfig.base,

        // // 优惠券
        // orderConfig.coupons,
        // 记录
        orderConfig.record
      ]
      this.getDetailFarmingExperience(orderId, orderItemId).then(e => {
        if (e.fromType == '21' && e.status == '5') {
          ext.splice(ext.length - 1, 0, orderConfig.physicalCoupon)
        }
        orderConfig.open({
          data: e,
          params: {
            data: e,
            customOrderId: orderId,
            customOrderItemId: orderItemId
          },
          executeFun: ext,
          onHidden: () => {
            this.getInit()
          },
          foot: ({ close, submit }) => {
            return [
              {
                name: '取消',
                onClick: close
              }
            ]
          }
        })
      })
    }
  }
}
